import {
  BoxFlex,
  FlexWrapper,
  IconAlignment,
  IconWrapper,
  RemarksDiv,
  ScoreFlex,
  SkilsBox,
  Wrapper,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/style'
import React, { Fragment } from 'react'

import { Form } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import DeleteIcon from 'components/icons/DeleteIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import {
  FormItem,
  SessionFlex,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import Status from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/Component/Status'
import { validateNumber } from 'utils/decimalValidation'

const RemarkRadioButton = ({
  formRef,
  feedbackList,
  setFeedBackList,
  interviewType,
}) => {
  const onDelete = name => {
    setFeedBackList(feedbackList?.filter((data, index) => index !== name))
  }

  const onClickField = (value, index, type) => {
    let feedback = feedbackList.map((data, indx) => {
      if (index === indx) {
        return {
          ...data,
          [type]: value,
        }
      } else {
        return data
      }
    })
    setFeedBackList(feedback)
  }

  const getOverallAverage = type => {
    let sumOfValue =
      feedbackList?.length > 0 &&
      feedbackList
        .map(data => data[type])
        .reduce((previousValue, currentValue) => {
          return (
            (previousValue ? Number(previousValue) : 0) +
            (currentValue ? Number(currentValue) : 0)
          )
        })

    return Number(sumOfValue) / Number(feedbackList?.length)
  }

  return (
    <Fragment>
      <RemarksDiv>Add Remark</RemarksDiv>

      {interviewType === 'ASSESMENT' ? (
        <Form.List name="feedback" ref={formRef}>
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...centerVerticallyrestField }) => (
                  <Fragment key={key + name}>
                    <SessionFlex centerVertically>
                      <Flex column>
                        <FormItem
                          name={[name, 'type']}
                          fieldKey={[name, 'type']}
                          rules={[
                            {
                              required: true,
                              message: 'Please enter label!',
                            },
                          ]}
                          ismargin
                        >
                          <RemarksDiv isMargin>Label - {name + 1}</RemarksDiv>
                          <Input
                            width="100%"
                            id={`feedback.${name}.type`}
                            placeholder="Label"
                            onChange={e =>
                              onClickField(e.target.value, name, 'type')
                            }
                            value={feedbackList[name]?.type}
                          />
                        </FormItem>
                        <FlexWrapper />
                        <ScoreFlex spaceBetween centerVertically>
                          <FormItem
                            name={[name, 'qp']}
                            fieldKey={[name, 'qp']}
                            rules={[
                              {
                                required: true,
                                message: 'Please enter qualifying score!',
                              },
                              {
                                validator: (_, value) => {
                                  let isValid = validateNumber(value)
                                  if (!isValid) {
                                    return Promise.reject(
                                      new Error('Not Valid')
                                    )
                                  }
                                  return Promise.resolve()
                                },
                              },
                            ]}
                            ismargin
                          >
                            <RemarksDiv isMargin>Qualifying score</RemarksDiv>
                            <Input
                              width="100%"
                              placeholder="Qualifying score"
                              id={`feedback.${name}.qp`}
                              onChange={e =>
                                onClickField(e.target.value, name, 'qp')
                              }
                              value={feedbackList[name]?.qp}
                              suffix={'%'}
                              type={'number'}
                            />
                          </FormItem>

                          <FormItem
                            name={[name, 'value']}
                            rules={[
                              {
                                required: true,
                                message: 'Please enter actual score!',
                              },
                              {
                                validator: (_, value) => {
                                  if (
                                    !/^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/.test(
                                      value
                                    )
                                  ) {
                                    return Promise.reject(
                                      new Error('Not Valid')
                                    )
                                  }
                                  return Promise.resolve()
                                },
                              },
                            ]}
                            ismargin
                          >
                            <RemarksDiv isMargin>Actual Score</RemarksDiv>
                            <Input
                              width="100%"
                              placeholder="Actual Score"
                              id={`feedback.${name}.value`}
                              onChange={e =>
                                onClickField(e.target.value, name, 'value')
                              }
                              value={feedbackList[name]?.value}
                              suffix={'%'}
                              type={'number'}
                            />
                          </FormItem>

                          <Flex ismargin column>
                            <RemarksDiv isMargin>Status</RemarksDiv>
                            <Status
                              status={
                                Number(feedbackList[name]?.qp) <=
                                Number(feedbackList[name]?.value)
                                  ? 'PASS'
                                  : 'FAIL'
                              }
                            />
                          </Flex>
                        </ScoreFlex>
                      </Flex>
                      <IconWrapper
                        center
                        onClick={() => {
                          remove(name)
                          onDelete(name)
                        }}
                        disable={feedbackList?.length === 1}
                      >
                        <DeleteIcon />
                      </IconWrapper>
                    </SessionFlex>
                    <Wrapper />
                  </Fragment>
                ))}
                <FlexWrapper />
                <Form.Item>
                  <Button.Secondary
                    text={'Add More field'}
                    width="100%"
                    icon={<PlusWhiteIcon />}
                    dashed="true"
                    onClick={() => {
                      add()
                    }}
                  />
                </Form.Item>
                <Fragment>
                  <SessionFlex centerVertically>
                    <Flex column>
                      <FormItem ismargin>
                        <RemarksDiv isMargin>Overall - Average</RemarksDiv>
                      </FormItem>
                      <FlexWrapper />
                      <ScoreFlex spaceBetween centerVertically>
                        <FormItem ismargin>
                          <RemarksDiv isMargin>Qualifying score</RemarksDiv>
                          <Input
                            width="100%"
                            placeholder="Qualifying score"
                            value={
                              feedbackList?.length > 1
                                ? parseInt(getOverallAverage('qp'))
                                : feedbackList[0]?.qp
                            }
                            disabled={true}
                            suffix={'%'}
                          />
                        </FormItem>

                        <FormItem ismargin>
                          <RemarksDiv isMargin>Actual Score</RemarksDiv>
                          <Input
                            width="100%"
                            placeholder="Actual Score"
                            value={
                              feedbackList?.length > 1
                                ? parseInt(getOverallAverage('value'))
                                : feedbackList[0]?.value
                            }
                            disabled={true}
                            suffix={'%'}
                          />
                        </FormItem>
                        <Flex ismargin column>
                          <RemarksDiv isMargin>Status</RemarksDiv>
                          <Status
                            status={
                              getOverallAverage('qp') <=
                              getOverallAverage('value')
                                ? 'PASS'
                                : 'FAIL'
                            }
                          />
                        </Flex>
                      </ScoreFlex>
                    </Flex>
                  </SessionFlex>
                  <Wrapper />
                </Fragment>
              </>
            )
          }}
        </Form.List>
      ) : (
        <Form.List name="feedback">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div key={key + name}>
                    <div>
                      <FormItem
                        name={[name, 'type']}
                        rules={[
                          {
                            required: true,
                            message: 'Please enter label name!',
                          },
                        ]}
                        ismargin={true}
                      >
                        <RemarksDiv>Label -{name + 1}</RemarksDiv>
                        <Input
                          width="100%"
                          id={`feedback.${name}.type`}
                          placeholder="Label"
                          onChange={e =>
                            onClickField(e.target.value, name, 'type')
                          }
                          value={feedbackList[name]?.type}
                          disable={true}
                        />
                      </FormItem>
                    </div>
                    <IconAlignment>
                      <FormItem
                        name={[name, 'value']}
                        rules={[
                          {
                            required: true,
                            message: 'Please select score!',
                          },
                          {
                            validator: (_, value) => {
                              if (value <= 0) {
                                return Promise.reject(
                                  new Error('Please select score!')
                                )
                              } else {
                                return Promise.resolve()
                              }
                            },
                          },
                        ]}
                        ismargin={true}
                      >
                        <RemarksDiv isMargin>
                          {feedbackList[name]?.type?.toLowerCase()}
                        </RemarksDiv>
                        <div>
                          <BoxFlex centerVertically>
                            {[1, 2, 3, 4, 5]?.map((count, index) => {
                              return (
                                <SkilsBox
                                  id={`feedback.${name}.value`}
                                  onClick={() =>
                                    onClickField(count, name, 'value')
                                  }
                                  isSelected={
                                    feedbackList[name]?.value === count
                                  }
                                  key={index + 'feedback'}
                                >
                                  {count}
                                </SkilsBox>
                              )
                            })}
                          </BoxFlex>
                        </div>
                      </FormItem>
                    </IconAlignment>
                  </div>
                ))}
              </>
            )
          }}
        </Form.List>
      )}
    </Fragment>
  )
}

export default RemarkRadioButton
